export default {
  // Options.jsx
  items_per_page: '/ ページ',
  jump_to: '移動',
  jump_to_confirm: '確認する',
  page: 'ページ',

  // Pagination.jsx
  prev_page: '前のページ',
  next_page: '次のページ',
  prev_5: '前 5ページ',
  next_5: '次 5ページ',
  prev_3: '前 3ページ',
  next_3: '次 3ページ'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-pagination@1.16.3@rc-pagination/es/locale/ja_JP.js
// module id = null
// module chunks = 